/**
 * Sección del agente (llave semántica) → ruta real del panel.
 * Vive JUNTO al router: si una ruta de React cambia, se actualiza AQUÍ
 * (mismo repo, mismo PR), sin tocar el agente. Llave desconocida → null
 * (no rebote mudo a /menu: el desajuste se ve en vez de esconderse).
 */
export const AGENT_ROUTE_MAP: Record<string, string> = {
  menu: '/menu',
  // Menú: productos y categorías del MENÚ se gestionan en la misma pantalla
  // (la lista de categorías Entradas/Comidas/Postres vive dentro de Products).
  productos: '/menu/productos',
  categorias: '/menu/productos',
  extras: '/menu/extras',
  secciones: '/menu/secciones',
  // Categorías del COMERCIO (giro del negocio) — distinto de las del menú.
  categorias_comercio: '/datos-del-comercio/categorias',
  horarios: '/horarios',
  ajustes: '/ajustes',
  sonido_pedidos: '/ajustes?section=sound',
  tema_menu: '/ajustes?section=theme',
  impresion: '/ajustes?section=printing',
  mensaje_comanda: '/ajustes?section=message',
  datos_comercio: '/datos-del-comercio',
  control_pedidos: '/control-pedidos',
  historial: '/historial-pedidos',
  estadisticas: '/estadisticas',
  cupones: '/cupones',
  anuncios: '/anuncios',
  integraciones: '/integraciones',
  pagos_en_linea: '/pedidos-en-linea',
  cobro_en_linea: '/configuracion-cobro-en-linea',
  mesas: '/mesas',
  usuarios: '/usuarios',
  mi_cuenta: '/mi-cuenta',
  compartir_menu: '/compartir-menu',
  perfil_social: '/perfil-social',
};

export const resolveAgentRoute = (seccion: string): string | null => AGENT_ROUTE_MAP[seccion] ?? null;
